export interface ICondition {
  Id: number;
  Condition: string;
  Reference: string;
  Information: string;
}

export const Colors = {
  Green: 'grön',
  Yellow: 'gul',
  Mixed: 'grön-gul',
}